import React, {useEffect, useState} from "react";
import { VERSION, EXT_TITLE } from "../../../../config/consts";
import * as Styled from "./styled";
import LogoIcon from "../../../../components/UI/Icons/LogoIcon";
import config from "../../../../config/config";

const MainLogo = () => {
  const [firstWord, setFirstWord] = useState("");
  const [restWords, setRestWords] = useState("");

  useEffect(() => {
    if (config?.appTitle) {
      const [first, ...restWords] = config.appTitle?.split(' ')?.filter(word => word.length > 0);
      if (restWords?.length > 0) {
        setFirstWord(first);
        setRestWords(restWords?.join(' '));
      } else {
        setRestWords(first);
      }

    }
  }, [])


  return (
    <Styled.HeaderLogo>
      <Styled.NavbarBrand to="/">
        {
          config.headerLogo && <LogoIcon
            type={config.headerLogo}
            title={`${config.appTitle || EXT_TITLE} ${VERSION}`}
            style={{maxHeight: '50px'}}
          />
        }
      </Styled.NavbarBrand>
      {
        (firstWord || restWords) && <Styled.NavbarSlogan><span>{firstWord}</span> {restWords}</Styled.NavbarSlogan>
      }
    </Styled.HeaderLogo>
  )
};

export default MainLogo;
